import app from 'flarum/forum/app';

import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import Button from 'flarum/common/components/Button';
import Discussion from 'flarum/common/models/Discussion';

export default function bookmarkButton(discussion: Discussion, className: string = '') {
  const bookmarked = discussion.attribute('bookmarked');

  return (
    <Button
      aria-label={app.translator.trans('clarkwinkelmann-bookmarks.forum.dropdownButton.' + (bookmarked ? 'remove' : 'add'))}
      onclick={(e: MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();

        if (!app.session.user) {
          // We use this instead of showing LogInModal so that extensions can override it
          DiscussionControls.replyAction.call(discussion, true);
          return;
        }

        discussion
          .save({
            bookmarked: !bookmarked,
          })
          .then(m.redraw());
      }}
      className={`Button Button--icon Button--flat ${className}`}
      icon={bookmarked ? 'fas fa-bookmark' : 'far fa-bookmark'}
    />
  );
}
